import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import useSupervisorHomeController from "../controllers/use-supervisor-home-controller";
import useSupervisorHomeData from "../controllers/use-supervisor-home-data";
import ActionQueue from "./action-queue";
import EvaluationsCard from "./evaluations-card";
import FlexCoverageCard from "./flex-coverage-card";
import HomeErrorState from "./home-error-state";
// import HomeFilterBar from "./home-filter-bar";
import HomeHeader from "./home-header";
import SnapshotKpis from "./snapshot-kpis";
import TeamTodayCard from "./team-today-card";

function SupervisorHomeDashboard() {
	const { t } = useTranslation();
	// The filter bar is parked until there's product handling for the requests
	// window and the location filter; put `requestsWindowDays` and
	// `changeRequestsWindow` back on this call when it comes back. The overview
	// call keeps using the default 7-day window in the meantime.
	const { refresh } = useSupervisorHomeController();
	const {
		snapshot,
		queue,
		enabledFeatures,
		isLoading,
		isInitialLoading,
		isError,
		fetchedAt,
		firstName,
	} = useSupervisorHomeData();

	const showEvaluations = enabledFeatures?.skillEvaluationForm !== false;

	return (
		<Box>
			<HomeHeader
				firstName={firstName}
				fetchedAt={fetchedAt}
				isLoading={isLoading}
				onRefresh={refresh}
			/>

			{isError ? (
				<HomeErrorState onRetry={refresh} />
			) : (
				<>
					{/* <HomeFilterBar
						requestsWindowDays={requestsWindowDays}
						onRequestsWindowChange={changeRequestsWindow}
						requestsPending={snapshot?.requestsPending}
					/> */}

					<Box sx={{ padding: "20px 24px 0" }}>
						<Typography
							component='h2'
							sx={{ fontSize: "1rem", fontWeight: 500, mb: 1.5 }}
						>
							{t("supervisor-home_at-a-glance")}
						</Typography>
						<SnapshotKpis
							snapshot={snapshot}
							enabledFeatures={enabledFeatures}
							isLoading={isInitialLoading}
						/>
					</Box>

					<Box
						sx={{
							display: "flex",
							alignItems: "flex-start",
							flexWrap: "wrap",
							gap: 3,
							padding: "8px 24px 24px",
						}}
					>
						<Box sx={{ flex: "1 1 520px", minWidth: 0 }}>
							<ActionQueue
								queue={queue}
								enabledFeatures={enabledFeatures}
								isLoading={isInitialLoading}
							/>
						</Box>

						<Box
							sx={{
								flex: "0 0 300px",
								minWidth: "300px",
								display: "flex",
								flexDirection: "column",
								gap: 2,
							}}
						>
							<FlexCoverageCard
								shiftsToday={snapshot?.shiftsToday}
								isLoading={isInitialLoading}
							/>
							<TeamTodayCard
								team={snapshot?.team}
								enabledFeatures={enabledFeatures}
								isLoading={isInitialLoading}
							/>
							{showEvaluations ? (
								<EvaluationsCard
									evaluations={snapshot?.evaluations}
									isLoading={isInitialLoading}
								/>
							) : null}
						</Box>
					</Box>
				</>
			)}
		</Box>
	);
}

export default SupervisorHomeDashboard;
